import TitleBlock from '@anm/components/TitleBlock';
import Image from '@anm/components/image/Image';
import { flexCenter, flexColumn, flexRow, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { Wrapper as AddDestinationButton } from '../AddDestinationButton';

type InfoSizes = 'small' | 'big';

export type RowProps = {
  size?: InfoSizes;
};

export const Subtitle = styled.span`
  color: #919eaa;
  font-weight: normal;
`;

export const Title = styled(TitleBlock)``;

export const Row = styled.div<RowProps>`
  ${flexRow};
  align-items: center;
  ${({ size }) => sizes[size || 'big']}
`;

export const DestinationInfoRow = styled(Row)``;

const titleAndBadgeRowMobile = media.phone`
  ${flexColumn};
`;

export const TitleAndBadgeRow = styled(Row)`
  ${titleAndBadgeRowMobile}
`;

const sizes: { [key in InfoSizes]: ReturnType<typeof css> } = {
  small: css`
    ${Title} {
      margin-bottom: 2px;

      h1,
      h2,
      h3,
      h4,
      h5 {
        font-size: 14px;
        line-height: 20px;
        font-weight: bold;
      }
    }

    ${Subtitle} {
      font-size: 12px;
      line-height: 20px;
    }
  `,
  big: css`
    ${Title} {
      margin-bottom: 7px;

      h1,
      h2,
      h3,
      h4,
      h5 {
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
      }
    }

    ${Subtitle} {
      font-size: 14px;
      line-height: 23px;
    }
  `
};

const connectWrapperMobile = media.phone`
  margin: 16px 0 0 70px;
`;

export const ConnectButtonWrapper = styled.div`
  ${flexRow};
  ${flexCenter};
  height: 40px;
  width: 150px;
  cursor: pointer;
  font-size: 14px;
  color: #292a2b;
  border-width: 1px;
  line-height: 20px;
  font-weight: bold;
  border-radius: 5px;
  border-style: solid;
  margin: 0 50px 0 auto;
  transition: all 200ms ease-in-out;
  border-color: rgba(1, 83, 130, 0.2);
  span {
    margin-left: 14px;
  }
  &:hover {
    background: #f5f7fa;
  }

  ${connectWrapperMobile};
`;

export const DeleteImageContainer = styled.div`
  ${flexCenter}
  top: 50%;
  right: 0;
  width: 40px;
  height: 40px;
  cursor: pointer;
  position: absolute;
  transform: translateY(-50%);
`;

export const DeleteImage = styled(Image)``;

export const InfoContainer = styled.div`
  ${flexColumn};
  flex: 1;
  overflow: hidden;
  min-height: 46px;
  margin-left: 20px;
  display: inline-flex;
`;

export const BudgesContainer = styled.div`
  margin-left: 11px;
`;

const mobileItem = media.phone`
  ${flexColumn};
  justify-content: flex-start;
  align-items: flex-start;

  ${BudgesContainer} {
    margin: 16px 0 0;
  }
`;

export const ItemWrapper = styled.div`
  ${flexRow};
  ${flexCenter};
  position: relative;
  padding: 16px 4px 20px;
  justify-content: flex-start;
  border-bottom: 1px solid #ccdde6;
  ${AddDestinationButton} {
    margin: 6px 0 0 6px;
  }

  ${mobileItem};
`;

export const ListWrapper = styled.div`
  & + ${ItemWrapper} {
    border: none;
  }
`;
